module.exports = __webpack_public_path__ + "media/ab-homepage/photocapt-c318c1c2.png";